import formatJSON, {DefaultOptions} from '../../CodeFormatters/JSONFormatter/formatJSON'
import pydict from '../../../../utils/pydict'

/**
 * 將 Python Dict 轉為 JSON
 * @param {string} input
 * @param {object} options
 * @returns {Promise<string>} output
 */
export default async function convertPyDictToJSON(input, options = {}) {
  const object = pydict.parse(input)
  const result = JSON.stringify(object)
  return formatJSON(result, {...DefaultOptions, ...options})
}
